import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'htmlToText' })
export class HtmlToTextPipe implements PipeTransform {
    transform(inputString: string): string {
        //return inputString.replace(/<[^>]*>?/gm, '');
        var parser = new DOMParser;
        var dom = parser.parseFromString(
            '<!doctype html><body>' + inputString,
            'text/html');
        return dom.body.textContent;
    }
}
